<template>
	<nav v-if="data" class="navbar navbar-default navbar-custom">
		<div class="container-fluid bold-400">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.id" class="navbar-brand navbar-brand-custom bold">
					<template v-if="data.provider">
						Pedido compra {{ $platform.setting.number_symbol }}{{ data.id }}
					</template>
					<template v-else>
						<template v-if="data.customer">
							Pedido venta {{ $platform.setting.number_symbol }}{{ data.id }}
						</template>
						<template v-else>
							Pedido {{ $platform.setting.number_symbol }}{{ data.id }}
						</template>
					</template>
				</router-link>
			</div>

			<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
				<ul class="nav navbar-nav">
					<li :class="'list-group-item-' + data.status.class">
						<a @click="$refs.ChangeStatus.open(data)" href="javascript:void(0)">
							<span v-html="data.status.icon"></span>
							<template v-if="data.status.lang">
								{{ data.status.lang.name }}
							</template>
							<template v-else>
								{{ data.status.name }}
							</template>
						</a>
					</li>
					<template v-if="data.parent">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.parent.id">
								<i class="fa fa-file-text" aria-hidden="true"></i>
								Pedido venta {{ $platform.setting.number_symbol }}{{ data.parent.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.customer">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + data.customer.id" :title="data.customer.name">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
								Cliente {{ $platform.setting.number_symbol }}<template v-if="$platform.setting.customers.custom_reference">{{ data.customer.reference }}</template><template v-else>{{ data.customer.id }}</template>
							</router-link>
						</li>
					</template>
					<template v-if="data.delivery_notes_count > 0">
						<li class="dropdown">
							<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
								<i class="fa fa-sticky-note-o" aria-hidden="true"></i>
								Albaranes
								<span class="caret"></span>
							</a>
							<template v-if="data.delivery_notes">
								<template v-if="data.delivery_notes.length">
									<ul class="dropdown-menu">
										<li v-for="delivery_note in data.delivery_notes">
											<router-link
											:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/deliverynotes/' + delivery_note.id">
												<i class="fa fa-sticky-note-o" aria-hidden="true"></i>
												Albarán {{ $platform.setting.number_symbol }}{{ delivery_note.id }}
											</router-link>
										</li>
										<template v-if="canGenerateDeliveryNote">
											<li role="separator" class="divider"></li>
											<li>
												<a @click="$refs.AddDeliveryNotes.open()" href="javascript:void(0)">
													<i class="fa fa-plus" aria-hidden="true"></i>
													Albarán
												</a>
											</li>
										</template>
									</ul>
								</template>
							</template>
						</li>
					</template>
					<template v-else>
						<li v-if="canGenerateDeliveryNote">
							<a @click="$refs.AddDeliveryNotes.open()" href="javascript:void(0)">
								<i class="fa fa-plus" aria-hidden="true"></i>
								Albarán
							</a>
						</li>
					</template>
					<template v-if="data.provider">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/providers/' + data.provider.id">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
								Proveedor {{ $platform.setting.number_symbol }}{{ data.provider.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.budget">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + data.budget.id">
								<i class="fa fa-clipboard" aria-hidden="true"></i>
								Presupuesto {{ $platform.setting.number_symbol }}{{ data.budget.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.invoice">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.invoice.id">
								<i aria-hidden="true" class="fa fa-clipboard"></i>
								<template v-if="data.provider">
									Factura {{ $platform.setting.number_symbol }}{{ data.invoice.prefix }}{{ data.invoice.number_invoice_provider }}
								</template>
								<template v-else>
									Factura {{ $platform.setting.number_symbol }}{{ data.invoice.prefix }}{{ data.invoice.number }}
								</template>
							</router-link>
						</li>
					</template>
					<template v-else>
						<template v-if="data.invoice_multiple">
							<li>
								<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.invoice_multiple.id">
									<i aria-hidden="true" class="fa fa-clipboard"></i>
									Factura {{ $platform.setting.number_symbol }}{{ data.invoice_multiple.prefix }}{{ data.invoice_multiple.number }}
								</router-link>
							</li>
						</template>
						<li v-else>
							<a @click="generateInvoice" href="javascript:void(0)">
								<i class="fa fa-plus" aria-hidden="true"></i>
								Factura
							</a>
						</li>
					</template>
					<template v-if="data.project">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + data.project.slug" :class="{ 'disabled' : user.hasRole('staff') }">
								<i class="fa fa-folder-o" aria-hidden="true"></i>
								Proyecto {{ $platform.setting.number_symbol }}{{ data.project.id }}
							</router-link>
						</li>
					</template>
					<template v-else>
						<!-- check if customer order -->
						<template v-if="data.order_status_id != 3">
							<li>
								<a @click="$refs.projectCreate.open(data)" href="javascript:void(0)">
									<i class="fa fa-plus" aria-hidden="true"></i>
									Proyecto
								</a>
							</li>
						</template>
					</template>
					<template v-if="!data.provider">
						<template v-if="data.products.length">
							<template v-if="hasProviders">
								<li v-if="canGenerateOrders">
									<a @click="generateOrders" href="javascript:void(0)" title="Generar pedidos a proveedores">
										<i class="fa fa-plus" aria-hidden="true"></i>
										Pedidos de compras
									</a>
								</li>
							</template>
						</template>
					</template>
				</ul>
				<ul class="nav navbar-nav navbar-right">
					<template v-if="data.delivery_notes_count > 0">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.id + '/deliverynotes'" title="Albaranes">
								<i class="fa fa-sticky-note-o" aria-hidden="true"></i>
								<span class="visible-xs visible-xs-navbar">
									Albaranes
								</span>
							</router-link>
						</li>
					</template>
					<template v-if="!data.provider">
						<template v-if="data.products.length">
							<template v-if="hasProviders">
								<li>
									<a @click="$refs.providers.open()" href="javascript:void(0)" title="Proveedores">
										<i aria-hidden="true" class="fa fa-truck fa-fw"></i>
										<span class="visible-xs visible-xs-navbar">
											Proveedores
										</span>
									</a>
								</li>
							</template>
						</template>
					</template>
					<template v-if="data.lock">
						<li>
							<a @click="lock()" href="javascript:void(0)" :title="$t('interface.unlock') | ucfirst">
								<i class="fa fa-lock" aria-hidden="true"></i>
								<span class="visible-xs visible-xs-navbar">
									{{ $t('interface.unlock') | ucfirst }}
								</span>
							</a>
						</li>
					</template>
					<template v-else>
						<li>
							<a @click="lock()" href="javascript:void(0)" :title="$t('interface.lock') | ucfirst">
								<i class="fa fa-unlock" aria-hidden="true"></i>
								<span class="visible-xs visible-xs-navbar">
									{{ $t('interface.lock') | ucfirst }}
								</span>
							</a>
						</li>
					</template>
					<li @click="$refs.SendEmail.open()">
						<a href="javascript:void(0)" :title="$t('interface.send') | ucfirst">
							<i class="fa fa-paper-plane" aria-hidden="true"></i>
							<span class="visible-xs visible-xs-navbar">
								{{ $t('interface.send') | ucfirst }}
							</span>
						</a>
					</li>
					<li v-if="canPirnt()" class="btn-group">
						<a @click="doPrint()" href="javascript:void(0)">
							<i class="fa fa-print" aria-hidden="true"></i>
							<span class="visible-xs visible-xs-navbar">
								{{ $t('interface.print') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<a :href="data.link" target= '_blank' title="PDF">
							<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							<span class="visible-xs visible-xs-navbar">
								Ver PDF
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<fab
			:type="type"
			:data="data"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>

		<send-email
			v-if="data"
			@reload="reload"
			ref="SendEmail"
			:item="data"
			:user="user"
			:isAuth="isAuth">
		</send-email>

		<project-create
			@reload="reload"
			@createTask="openTaskCreate"
			ref="projectCreate"
			:user="user"
			:isAuth="isAuth">
		</project-create>

		<task-create
			ref="taskCreate"
			@openCreateSchedule="openCreateSchedule"
			@reload="reload"
			:order="data"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			ref="schedulecreate"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>

		<providers
			ref="providers"
			@reload="reload"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</providers>

		<generate-order-provider
			ref="GenerateOrderProvider"
			@reload="reload"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</generate-order-provider>

		<change-status
			@reload="reload"
			ref="ChangeStatus"
			:user="user"
			:isAuth="isAuth">
		</change-status>

		<add-delivery-notes
			@reload="reload"
			ref="AddDeliveryNotes"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</add-delivery-notes>
	</nav>
</template>

<script>
	import swal from 'sweetalert2'
	import Fav from './Fab'
	import SendEmail from './SendEmail'
	import Providers from './Providers.vue'
	import GenerateOrderProvider from './GenerateOrderProvider.vue'
	import ChangeStatus from './ChangeStatus'
	import AddDeliveryNotes from './AddDeliveryNotes'
	//-- PROJECTS
		import ProjectCreate from '@/components/projects/projects/views/Create.vue'
		import TaskCreate from '@/components/projects/tasks/views/Create.vue'
		import ScheduleCreate from '@/components/projects/schedules/views/Create.vue'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			'fab': Fav,

			'send-email': SendEmail,
			'providers': Providers,
			'generate-order-provider': GenerateOrderProvider,
			'change-status': ChangeStatus,

			'project-create': ProjectCreate,
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
			'add-delivery-notes': AddDeliveryNotes,
		},
		data () {
			return {

			}
		},
		computed: {
			hasProviders() {
				var has = false
				if(this.data) {
					if(this.data.products) {
						if(this.data.products.length) {
							for (var i = 0; i < this.data.products.length; i++) {
								var product = this.data.products[i]
								if(product.provider_id) {
									has = true
									break;
								}
							}
						}
					}
				}
				return has
			},
			canGenerateOrders() {
				var can = false

				if(this.data) {
					if(this.data.providers) {
						if(this.data.providers.length) {
							for (var i = this.data.providers.length - 1; i >= 0; i--) {
								var provider = this.data.providers[i]
								if(provider.product_storages) {
									if(provider.product_storages.length) {
										for (var k = provider.product_storages.length - 1; k >= 0; k--) {
											var product = provider.product_storages[k]

											if(!product.order_provider_id) {
												var can = true
											}
										}
									}
								}
							}
						}
					}
				}

				return can
			},
			canGenerateDeliveryNote() {
				var can = false
				var products = null
				if(this.data) {
					if(this.data.products) {
						if(this.data.products.length) {
							products = this.data.products.filter(function(product) {
								if(!product.product_delivery_note_storage) {
									return product
								}
							})
						}
					}
				}
				if(products) {
					if(products.length) {
						if(products.length > 0) {
							can = true
						}

					}
				}
				return can
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			//--
			doPrint() {
				$(".printableArea").printThis({
					canvas: true,
				})
			},
			canPirnt() {
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.name) {
							if(this.$route.meta.name == 'show') {
								return true
							}
						}
					}
				}

				return false
			},
			lock() {
				var that = this
				if(this.data.lock) {
					var title = 'Pedido bloqueado'
					var text = '¿Desbloquear?'
					var type = 'info'

					var api = 'admin/management/orders/' + that.data.id + '/unlock'
				} else {
					var title = 'Pedido sin bloquear'
					var text = '¿Bloquear?'
					var type = 'info'

					var api = 'admin/management/orders/' + that.data.id + '/lock'
				}
				swal.queue([{
						title: title,
						text: text,
						type: type,
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							that.loading = true
							return new Promise(function (resolve) {
								that.$http.get(api)
								.then(response => {
									that.loading = false
									var path = '/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + that.data.id
									if(that.$route.fullPath != path) {
										that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + that.data.id)
									} else {
										that.reload()
									}
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								}).catch(function(response) {
									console.log(response)
									that.loading = false
									that.reload()
								})
							})
						}
					}]).catch(swal.noop)
			},
			generateInvoice() {
				var that = this
				var tax_id = this.$platform.setting.tax_id
				if(this.data.tax_id) {
					var tax_id = this.data.tax_id
				}

				var data = {
					customer_id: this.data.customer_id,
					provider_id: this.data.provider_id,
					budget_id: this.data.budget_id,
					order_id: this.data.id,
					project_id: this.data.project_id,
					tax_id: tax_id,
				}

				if(data.customer_id) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: "Se añadirá una factura de venta",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.post('admin/management/invoices', data)
								.then(response => {
									that.reload()
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									if(response.status == 409) {
										swal(response.body.title, response.body.text, response.body.type);
									} else {
										swal({
											title: response.statusText,
											text: response.body,
											type: "warning"
										});
									}
								})
							})
						}
					}]).catch(swal.noop)
				} else {
					if(data.provider_id) {
						swal.queue([{
							title: that.$t("messages.attention"),
							text: "Se añadirá una factura de compra",
							type: "warning",
							input: 'text',
							inputPlaceholder: 'Nº Factura',
							showCancelButton: true,
							confirmButtonColor: "#53e69d",
							cancelButtonColor: "#ff7676",
							confirmButtonText: "Si",
							cancelButtonText: "No",
							showLoaderOnConfirm: true,
							preConfirm: function (number_invoice_provider) {
								return new Promise(function (resolve) {
									if(number_invoice_provider) {
										data.number_invoice_provider = number_invoice_provider
									}
									that.$http.post('admin/management/invoices', data)
									.then(response => {
										that.reload()
										swal(response.body.title, response.body.text, response.body.type);
									}).catch(function(response) {
										if(response.status == 409) {
											swal(response.body.title, response.body.text, response.body.type);
										} else {
											swal({
												title: response.statusText,
												text: response.body,
												type: "warning"
											});
										}
									})
								})
							}
						}]).catch(swal.noop)
					}
				}
			},
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open(this.data)
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data, null, null, this.data)
			},
			generateOrders() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.purchase_orders_will_be_added"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/orders/' + that.data.id + '/generate/orders')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			//--
			changeStatus(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				if(this.data.status.id) {
					this.$http.get('admin/management/budgets/' + this.data.id + '/change/status/' + this.data.status.id)
						.then(response => {
							select.removeAttribute('disabled')
							this.reload()
						}).catch(response => {
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.reload()
						})
				}
			},
			openGenerateOrderProvider(product, provider) {
				this.$refs.GenerateOrderProvider.open(product, provider)
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Navbar.vue